export type DeleteAttribute = {
    attributeId: number;
}

export const DELETE_ATTRIBUTE: DeleteAttribute = {
    attributeId: 0,
}